export default __webpack_public_path__ + "static/media/keypad-icon.294bacff.svg";